import { produce } from 'immer';

import {
    REGISTRATION_DATA
} from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/registration/constants';
import {
    UPGRADE_DATA
} from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/constants';
import {
    FORGOT_PIN_DATA
} from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/steps/ForgotPinStep/constants';
import {
    RETAIL_REG_DATA
} from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/retailReg/constants';
import {
    RETAIL_UPGRADE_DATA
} from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/retailUpgrade/constants';
import {
    SLOT_UPGRADE_DATA
} from '@interlayer/js/app/components/main/Registration/components/templates/SlotReg/components/slotUpgrade/constants';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

import {
    actionTypes,
    DEFAULT_ADDITIONAL_RETAIL_UPGRADE_DATA,
    DEFAULT_ADDITIONAL_UPGRADE_DATA,
    DEFAULT_ERROR_REG_DATA,
    ONLINE_REG_BUSINESS_PHASES,
    STEP_NAMES
} from './constants';
import { TRegistrationAction, TRegistrationState } from './types';

export const defaultState: TRegistrationState = {
    attemptId: '',
    config: {},
    nextStepIndex: null,
    isRegistered: false,
    isDestroyed: false,
    isUpgrade: false,
    isShowClosePopup: false,
    isSuccessRetailReg: false,
    isManuallyAddress: false,
    isShowPopupAlreadyMember: false,
    forceToChangeEmail: false,
    isLoadingSendForm: false,
    isRegistrationInProcess: false,
    registrationNameStep: STEP_NAMES.JOIN_STEP,
    errorRegistration: DEFAULT_ERROR_REG_DATA,
    forgotPinData: FORGOT_PIN_DATA,
    registrationsData: REGISTRATION_DATA,
    retailRegData: RETAIL_REG_DATA,
    retailUpgradeData: RETAIL_UPGRADE_DATA,
    slotUpgradeData: SLOT_UPGRADE_DATA,
    upgradeData: UPGRADE_DATA,
    additionalRetailUpgradeData: DEFAULT_ADDITIONAL_RETAIL_UPGRADE_DATA,
    additionalUpgradeData: DEFAULT_ADDITIONAL_UPGRADE_DATA,
    lastFieldName: 'unknown',
    occupationSuggestions: [],
    isShowReCaptcha: false,
    retailWrapperType: '',
    buyapowaUserId: '',
    businessPhase: ONLINE_REG_BUSINESS_PHASES.online
};

export const reducer = produce((draftState, action: TRegistrationAction): TRegistrationState | void => {
    switch (action.type) {
        case actionTypes.SET_INITIAL_STATE: {
            Object.assign(draftState, defaultState, {
                config: draftState.config,
                isRegistrationInProcess: draftState.isRegistrationInProcess
            });
            break;
        }
        case actionTypes.SET_UPGRADE_INITIAL_STATE: {
            Object.assign(draftState, defaultState, {
                config: draftState.config,
                isUpgrade: true,
                registrationNameStep: STEP_NAMES.MEMBERSHIP_STEP,
                isRegistrationInProcess: draftState.isRegistrationInProcess
            });
            break;
        }
        case actionTypes.SET_CONFIG: {
            draftState.config = action.payload;
            break;
        }
        case actionTypes.SET_ATTEMPT_ID: {
            draftState.attemptId = action.payload;
            break;
        }
        case actionTypes.SET_IS_DESTROYED: {
            draftState.isDestroyed = action.payload;
            break;
        }
        case actionTypes.SET_FORCE_TO_CHANGE_EMAIL: {
            draftState.forceToChangeEmail = action.payload;
            break;
        }
        case actionTypes.SET_IS_LOADING_SEND_FORM: {
            draftState.isLoadingSendForm = action.payload;
            break;
        }
        case actionTypes.SET_IS_REGISTRATION_IN_PROCESS: {
            draftState.isRegistrationInProcess = action.payload;
            break;
        }
        case actionTypes.SET_IS_UPGRADE: {
            draftState.isUpgrade = action.payload;
            break;
        }
        case actionTypes.SET_IS_REGISTERED: {
            draftState.isRegistered = action.payload;
            break;
        }
        case actionTypes.SET_IS_MANUALLY_ADDRESS: {
            draftState.isManuallyAddress = action.payload;
            break;
        }
        case actionTypes.SET_IS_SHOW_POPUP_ALREADY_MEMBER: {
            draftState.isShowPopupAlreadyMember = action.payload;
            break;
        }
        case actionTypes.SET_IS_SHOW_CLOSE_POPUP: {
            draftState.isShowClosePopup = action.payload;
            break;
        }
        case actionTypes.SET_NEXT_STEP_INDEX: {
            draftState.nextStepIndex = action.payload;
            break;
        }
        case actionTypes.SET_ADDITIONAL_RETAIL_UPGRADE_DATA: {
            Object.assign(draftState.additionalRetailUpgradeData, action.payload);
            break;
        }
        case actionTypes.SET_ADDITIONAL_UPGRADE_DATA: {
            Object.assign(draftState.additionalUpgradeData, action.payload);
            break;
        }
        case actionTypes.SET_REGISTRATION_NAME_STEP: {
            draftState.registrationNameStep = action.payload;
            break;
        }
        case actionTypes.SET_RETAIL_REG_DATA: {
            if (!draftState.retailRegData[action.payload.stepName]) {
                break;
            }

            Object.assign(draftState.retailRegData[action.payload.stepName], action.payload.data);
            break;
        }
        case actionTypes.SET_RETAIL_UPGRADE_DATA: {
            if (!draftState.retailUpgradeData[action.payload.stepName]) {
                break;
            }

            Object.assign(draftState.retailUpgradeData[action.payload.stepName], action.payload.data);
            break;
        }
        case actionTypes.SET_SLOT_UPGRADE_DATA: {
            if (!draftState.slotUpgradeData[action.payload.stepName]) {
                break;
            }

            Object.assign(draftState.slotUpgradeData[action.payload.stepName], action.payload.data);
            break;
        }
        case actionTypes.SET_REGISTRATION_DATA: {
            if (!draftState.registrationsData[action.payload.stepName]) {
                break;
            }

            Object.assign(draftState.registrationsData[action.payload.stepName], action.payload.data);
            break;
        }
        case actionTypes.SET_UPGRADE_DATA: {
            if (!draftState.upgradeData[action.payload.stepName]) {
                break;
            }

            Object.assign(draftState.upgradeData[action.payload.stepName], action.payload.data);
            break;
        }
        case actionTypes.SET_ERROR_REGISTRATION: {
            Object.assign(draftState.errorRegistration, action.payload);
            break;
        }
        case actionTypes.SET_LAST_FIELD_NAME: {
            draftState.lastFieldName = action.payload;
            break;
        }
        case actionTypes.SET_FORGOT_PIN_DATA: {
            const { parameters = {}, ...forgotPinStepData } = action.payload;

            Object.assign(draftState, {
                forgotPinData: {
                    ...draftState.forgotPinData,
                    ...forgotPinStepData,
                    parameters: {
                        ...draftState.forgotPinData.parameters,
                        ...parameters
                    }
                }
            });
            break;
        }
        case actionTypes.RESET_FORGOT_PIN_DATA: {
            Object.assign(draftState.forgotPinData, FORGOT_PIN_DATA);
            break;
        }
        case actionTypes.SET_OCCUPATION_SUGGESTIONS: {
            draftState.occupationSuggestions = action.payload;
            break;
        }
        case actionTypes.SET_IS_SHOW_RECAPTCHA: {
            draftState.isShowReCaptcha = action.payload;
            break;
        }
        case actionTypes.SET_IS_SUCCESS_RETAIL_REG: {
            draftState.isSuccessRetailReg = action.payload;
            break;
        }
        case actionTypes.SET_REGISTRATION_RETAIL_WRAPPER_TYPE: {
            draftState.retailWrapperType = action.payload;
            break;
        }
        case actionTypes.SET_BUYAPOWA_DATA: {
            draftState.buyapowaUserId = action.payload.buyapowaUserId;

            if (action.payload.type === 'registration') {
                draftState.registrationsData[STEP_NAMES.JOIN_STEP][VALIDATION_FIELDS.email] = action.payload.email;
                draftState.registrationsData[STEP_NAMES.PERSONAL_STEP][VALIDATION_FIELDS.firstname] = action.payload.firstname;
                draftState.registrationsData[STEP_NAMES.PERSONAL_STEP][VALIDATION_FIELDS.lastname] = action.payload.lastname;
            }

            if (action.payload.type === 'retailReg') {
                draftState.retailRegData[STEP_NAMES.PERSONAL_RETAIL_STEP][VALIDATION_FIELDS.email] = action.payload.email;
                draftState.retailRegData[STEP_NAMES.PERSONAL_RETAIL_STEP][VALIDATION_FIELDS.firstname] = action.payload.firstname;
                draftState.retailRegData[STEP_NAMES.PERSONAL_RETAIL_STEP][VALIDATION_FIELDS.lastname] = action.payload.lastname;
            }

            break;
        }
        case actionTypes.SET_BUSINESS_PHASES: {
            draftState.businessPhase = action.payload;
            break;
        }
        default:
            break;
    }
}, defaultState);
